import React, { Component } from "react";

interface IGameAutoplayComponent {
    data: {}
}
export const gameAutoplayComponent: IGameAutoplayComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                
                    {
                        "id": "gameAutoplayContentPortait",
                        "name": "gameAutoplayContentPortait",
                        "type": "Container",
                        "x": 0,
                        "y": 1050,
                        "visible": true,
                        "filterTypes": [],
                        child: [


                            {
                                "id": "stopOnAnyWinContainerPortait",
                                "name": "stopOnAnyWinContainerPortait",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "id": "stopOnAnyWin_text",
                                        "name": "stopOnAnyWin_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "stopOnWinText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },

                                    {
                                        "name": "stopOnAnyWin_enablePortait",
                                        "image": "setting_radio_btn_enable.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },
                                    {
                                        "name": "stopOnAnyWin_disablePortait",
                                        "image": "setting_radio_btn_disbale.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },
                                    },

                                    {
                                        "name": "stopOnAnyWin_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            {
                                "id": "stopfeaturetriggeredContainerPortait",
                                "name": "stopfeaturetriggeredContainerPortait",
                                "type": "Container",
                                "x": 0,
                                "y": 150,
                                "visible": true,
                                child: [
                                    {
                                        "id": "stopfeaturetriggered_text",
                                        "name": "stopfeaturetriggered_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "stopfeaturetriggeredText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "stopfeaturetriggered_enablePortait",
                                        "image": "setting_radio_btn_enable.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },
                                    {
                                        "name": "stopfeaturetriggered_disablePortait",
                                        "image": "setting_radio_btn_disbale.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },
                                    },

                                    {
                                        "name": "stopfeaturetriggered_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            {
                                "id": "singlewinlimitContainerPortait",
                                "name": "singlewinlimitContainerPortait",
                                "type": "Container",
                                "x": 0,
                                "y": 300,
                                "visible": true,
                                child: [
                                    {
                                        "id": "singlewinlimit_text",
                                        "name": "singlewinlimit_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "singleWinLimitText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "singlewinlimit_disablePortait",
                                        "image": "num_shell.png",
                                        "type": "Image",
                                        "interactive": true,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 126,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                    },
                                    {
                                        "name": "nummShellTxtFieldPortait",
                                        "image": "num_shell.png",
                                        "type": "Image",
                                        "interactive": true,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 126,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                    },

                                    {
                                        "name": "singlewinlimit_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",

                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },
                                    {
                                        "id": "singlewinlimit_ValuePortait",
                                        "name": "singlewinlimit_ValuePortait",
                                        "type": "Text",
                                        "x": 1208,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "0.00",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#000000'],
                                        },
                                    },
                                ]
                            },
                            {
                                "id": "winLimitContainerPortait",
                                "name": "winLimitContainerPortait",
                                "type": "Container",
                                "x": 0,
                                "y": 450,
                                "visible": true,
                                child: [
                                    {
                                        "id": "winLimit_text",
                                        "name": "winLimit_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "winLimitText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "winLimit_disablePortait",
                                        "image": "num_shell.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 126,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                    },

                                    {
                                        "name": "winLimit_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },
                                    {
                                        "id": "winlimit_ValuePortait",
                                        "name": "winlimit_ValuePortait",
                                        "type": "Text",
                                        "x": 1208,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "0.00",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#000000'],
                                        },
                                    },
                                ]
                            },
                            {
                                "id": "lossLimitContainerPortait",
                                "name": "lossLimitContainerPortait",
                                "type": "Container",
                                "x": 0,
                                "y": 600,
                                "visible": true,
                                child: [
                                    {
                                        "id": "lossLimit_text",
                                        "name": "lossLimit_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "setting_loss-limit",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "lossLimit_disablePortait",
                                        "image": "num_shell.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 126,
                                        "height": 32,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                    },

                                    {
                                        "name": "lossLimit_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },
                                    {
                                        "id": "lossLimit_ValuePortait",
                                        "name": "lossLimit_ValuePortait",
                                        "type": "Text",
                                        "x": 1208,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "0.00",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#000000'],
                                        },
                                    },
                                ]
                            },
                        ]
                    },
                ]
            },

        ],
    }


};

export const GameAutoplayComponentConfigurationContext = React.createContext(
    {}
);